import { describe, expect, it } from 'vitest';
import { hasCompanyActivityInfo } from './company-activity';

function createOrganization(attrs: Record<string, unknown>) {
  return {
    get: (key: string) => attrs[key],
  };
}

describe('hasCompanyActivityInfo', () => {
  it('is false when transfer countries are missing', () => {
    expect(
      hasCompanyActivityInfo(
        createOrganization({
          incomingTransfersOrigin: ['FR'],
          outgoingTransfersDestination: [],
        })
      )
    ).toBe(false);
  });

  it('requires business relationships for any organization', () => {
    expect(
      hasCompanyActivityInfo(
        createOrganization({
          businessRelationships: ['suppliers_buyers_relationships'],
          legalRegistrationDate: '2099-01-01',
          incomingTransfersOrigin: ['FR'],
          outgoingTransfersDestination: ['FR'],
        })
      )
    ).toBe(true);
  });

  it('requires the other free-text when other is selected', () => {
    expect(
      hasCompanyActivityInfo(
        createOrganization({
          incomingTransfersOrigin: ['FR'],
          outgoingTransfersDestination: ['FR'],
          businessRelationships: ['other'],
          businessRelationshipsOther: '  ',
        })
      )
    ).toBe(false);

    expect(
      hasCompanyActivityInfo(
        createOrganization({
          incomingTransfersOrigin: ['FR'],
          outgoingTransfersDestination: ['FR'],
          businessRelationships: ['other'],
          businessRelationshipsOther: 'Family gift',
        })
      )
    ).toBe(true);
  });
});
